<template>
  <div class="icon" @click="$emit('click')" :style="style"></div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      required: true
    }
  },
  computed: {
    style () {
      let file
      switch (this.type) {
        case 'arrow_edit_open':
          file = `pr_${this.type}.png`
          break
        default:
          file = `pr_icon_${this.type}.png`
      }
      return `background-image: url('http://az.img.nutsbp.com/007/image/nuts_dartcome/pc/pr/cut_page/${file}')`
    }
  }
}
</script>

<style lang="postcss" scoped>
.icon {
  vertical-align: middle;
  background-position: center;
  background-repeat: no-repeat;
}
</style>



// WEBPACK FOOTER //
// src/components/icon/Icon.vue